import { render, staticRenderFns } from "./EditClass.vue?vue&type=template&id=8ec54690&"
import script from "./EditClass.vue?vue&type=script&lang=js&"
export * from "./EditClass.vue?vue&type=script&lang=js&"
import style0 from "./EditClass.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports